import { detailedDiff, DetailedDiff, updatedDiff } from 'deep-object-diff';

export function detailed<T>(lhs: T, rhs: T): DetailedDiff {
  const diff = detailedDiff(lhs as object, rhs as object);
  // cleanup prototype
  return JSON.parse(JSON.stringify(diff));
}

export function updated<T>(lhs: T, rhs: T): Partial<T> {
  const diff = updatedDiff(lhs as object, rhs as object);
  // cleanup prototype
  return JSON.parse(JSON.stringify(diff));
}
